export const NavBarStyles = { 
    baseStyles: {},
    sizes: {},
    variants: {},
    defaultProps: {},
}